import create_mocked_environment from '../graphql/create_environment';

import orgs_and_suborgs from './orgs_and_suborgs';
import user from './user';
import accounts from './accounts';

const environment = {
  Query: () => ({
    ...orgs_and_suborgs.query,
    ...accounts.query,
    ...user.query
  }),
  ...accounts.types,
  ...user.types
}


export default create_mocked_environment(environment);
